(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dali", [], factory);
	else if(typeof exports === 'object')
		exports["dali"] = factory();
	else
		root["dali"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bootstrap = __webpack_require__(1);
	
	Object.defineProperty(exports, 'bootstrap', {
	  enumerable: true,
	  get: function get() {
	    return _bootstrap.bootstrap;
	  }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bootstrap = bootstrap;
	
	var _util = __webpack_require__(2);
	
	var _Injector = __webpack_require__(3);
	
	var _Router = __webpack_require__(4);
	
	var _Components = __webpack_require__(6);
	
	var _Bindable = __webpack_require__(18);
	
	var _i18n = __webpack_require__(19);
	
	var _EventBus = __webpack_require__(5);
	
	(0, _util.log)('bootstrap.js');
	
	function bootstrap(target) {
	  _EventBus.EventBus.subscribe(_i18n.i18n.TRANSLATION_LOADED, function () {
	    _Injector.Injector.get(target).run();
	    _Router.Router.run();
	    _Components.Components.run();
	    _Bindable.Binder.run();
	  });
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDescriptor = isDescriptor;
	exports.decorate = decorate;
	exports.first = first;
	exports.last = last;
	exports.ucfirst = ucfirst;
	exports.log = log;
	exports.guid = guid;
	exports.merge = merge;
	exports.cloneFunc = cloneFunc;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	if (!Object.assign) {
	  Object.defineProperty(Object, 'assign', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: function value(target) {
	      'use strict';
	
	      if (target === undefined || target === null) {
	        throw new TypeError('Cannot convert first argument to object');
	      }
	
	      var to = Object(target);
	      for (var i = 1; i < arguments.length; i++) {
	        var nextSource = arguments[i];
	        if (nextSource === undefined || nextSource === null) {
	          continue;
	        }
	        nextSource = Object(nextSource);
	
	        var keysArray = Object.keys(nextSource);
	        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	          var nextKey = keysArray[nextIndex];
	          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	          if (desc !== undefined && desc.enumerable) {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	      return to;
	    }
	  });
	}
	
	function isDescriptor(desc) {
	  if (!desc || !desc.hasOwnProperty) {
	    return false;
	  }
	
	  var keys = ['value', 'get', 'set'];
	
	  for (var i = 0, l = keys.length; i < l; i++) {
	    if (desc.hasOwnProperty(keys[i])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function decorate(handleDescriptor, entryArgs) {
	  if (isDescriptor(entryArgs[entryArgs.length - 1])) {
	    return handleDescriptor.apply(undefined, _toConsumableArray(entryArgs).concat([[]]));
	  }
	
	  return function () {
	    return handleDescriptor.apply(undefined, Array.prototype.slice.call(arguments).concat([entryArgs]));
	  };
	}
	
	function first() {
	  return this[0];
	}
	
	function last() {
	  return this[this.length - 1];
	}
	
	function ucfirst() {
	  var f = this.charAt(0).toUpperCase();
	  return f + this.substr(1);
	}
	
	function log() {
	  // console.log(arguments);
	}
	
	function guid() {
	  function _p8(s) {
	    var p = (Math.random().toString(16) + '000000000').substr(2, 8);
	    return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
	  }
	
	  return _p8() + _p8(true) + _p8(true) + _p8();
	}
	
	function merge(obj1, obj2) {
	  return Object.assign(obj1, obj2);
	}
	
	function cloneFunc(func) {
	  var reFn = /^function\s*([^\s(]*)\s*\(([^)]*)\)[^{]*\{([^]*)\}$/gi,
	      s = func.toString().replace(/^\s|\s$/g, ''),
	      m = reFn.exec(s);
	
	  if (!m || !m.length) return;
	
	  var conf = {
	    name: m[1] || '',
	    args: m[2].replace(/\s+/g, '').split(','),
	    body: m[3] || ''
	  };
	
	  return Function.prototype.constructor.apply(this, [].concat(conf.args, conf.body));
	}
	
	log('util.js');

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Injector = exports.Injector = (_temp = _class = function () {
	  function Injector() {
	    _classCallCheck(this, Injector);
	  }
	
	  _createClass(Injector, null, [{
	    key: "hasInstance",
	    value: function hasInstance(name) {
	      return !!Injector.instances.hasOwnProperty(name);
	    }
	  }, {
	    key: "instantiate",
	    value: function instantiate(target) {
	      var instance = undefined;
	
	      if (!!Injector.hasInstance(target.name)) {
	        instance = Injector.instances[target.name];
	      } else {
	        instance = Injector.resolve(target);
	        Injector.instances[target.name] = instance;
	      }
	
	      return instance;
	    }
	  }, {
	    key: "resolve",
	    value: function resolve(target) {
	      var dependencies = {};
	
	      if (!!target.dependencies) {
	        dependencies = target.dependencies.map(function (target) {
	          return Injector.instantiate(target);
	        });
	      }
	
	      var proto = target.prototype,
	          instance = Object(proto) === proto ? Object.create(proto) : {},
	          result = Function.prototype.apply.call(target, instance, dependencies);
	
	      return Object(result) === result ? result : instance;
	    }
	  }, {
	    key: "get",
	    value: function get(target) {
	      return Injector.instantiate(target);
	    }
	  }]);
	
	  return Injector;
	}(), _class.instances = {}, _temp);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Router = undefined;
	
	var _EventBus = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Router = exports.Router = (_temp = _class = function () {
	  function Router() {
	    _classCallCheck(this, Router);
	  }
	
	  _createClass(Router, null, [{
	    key: 'getHash',
	    value: function getHash() {
	      return window.location.hash.substring(1);
	    }
	  }, {
	    key: 'exists',
	    value: function exists() {
	      var routes = Router.routes.filter(function (route) {
	        var path = route.value.path;
	
	        if (!!path.test(Router.getHash())) {
	          return route;
	        }
	      });
	
	      return routes.length === 1;
	    }
	  }, {
	    key: 'route',
	    value: function route() {
	      Router.routes.forEach(function (route) {
	        var path = route.value.path;
	
	        if (!!path.test(Router.getHash())) {
	          _EventBus.EventBus.publish(Router.ROUTE_CHANGED, route);
	        }
	      });
	    }
	  }, {
	    key: 'routeTo',
	    value: function routeTo(route) {
	      window.location.hash = route.value.url;
	    }
	  }, {
	    key: 'routeToDefault',
	    value: function routeToDefault() {
	      Router.routes.forEach(function (route) {
	        if (!!route.value.hasOwnProperty('default')) {
	          window.location.hash = route.value.url;
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load() {
	      var history = window.location.hash;
	      window.location.hash = '#' + +new Date();
	      window.location.hash = history;
	    }
	  }, {
	    key: 'run',
	    value: function run() {
	      if (window.location.hash.length === 0) {
	        Router.routeToDefault();
	      }
	
	      window.addEventListener('hashchange', Router.route, false);
	      window.addEventListener('load', Router.load, false);
	    }
	  }]);
	
	  return Router;
	}(), _class.routes = [], _temp);
	
	Router.ROUTE_CHANGED = 'ROUTE_CHANGED';

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventBus = exports.EventBus = (_temp = _class = function () {
	  function EventBus() {
	    _classCallCheck(this, EventBus);
	  }
	
	  _createClass(EventBus, null, [{
	    key: 'subscribe',
	    value: function subscribe(topic, callback) {
	      if (!EventBus.topics.hasOwnProperty(topic)) {
	        EventBus.topics[topic] = [];
	      }
	
	      var token = (++EventBus.lastUid).toString();
	
	      EventBus.topics[topic].push({ token: token, callback: callback });
	
	      return token;
	    }
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe(token) {
	      for (var m in EventBus.topics) {
	        if (EventBus.topics.hasOwnProperty(m)) {
	          for (var i = 0, j = EventBus.topics[m].length; i < j; i++) {
	            if (EventBus.topics[m][i].token === token) {
	              EventBus.topics[m].splice(i, 1);
	              return token;
	            }
	          }
	
	          delete EventBus.topics[m];
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'publish',
	    value: function publish(topic, data) {
	      if (!EventBus.topics.hasOwnProperty(topic)) {
	        return false;
	      }
	
	      function notify() {
	        var subscribers = EventBus.topics[topic],
	            throwException = function throwException(e) {
	          return function () {
	            throw e;
	          };
	        };
	
	        for (var i = 0, j = subscribers.length; i < j; i++) {
	          try {
	            subscribers[i].callback(topic, data);
	          } catch (e) {
	            setTimeout(throwException(e), 0);
	          }
	        }
	      }
	
	      notify();
	
	      return true;
	    }
	  }]);
	
	  return EventBus;
	}(), _class.topics = {}, _class.lastUid = -1, _temp);
	
	EventBus.CHANGE_DETECTED = 'CHANGE_DETECTED';
	EventBus.MODEL_CHANGE_DETECTED = 'MODEL_CHANGE_DETECTED';

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Components = undefined;
	
	var _dom = __webpack_require__(7);
	
	var _Views = __webpack_require__(8);
	
	var _DataComponents = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Components = exports.Components = function () {
	  function Components() {
	    _classCallCheck(this, Components);
	  }
	
	  _createClass(Components, null, [{
	    key: 'components',
	    value: function components() {
	      return _DataComponents.DataComponents.data;
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize(element) {
	      return _DataComponents.DataComponents.normalize(element.nodeName);
	    }
	  }, {
	    key: 'exists',
	    value: function exists(name) {
	      return !!_DataComponents.DataComponents.get(name);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return _DataComponents.DataComponents.get(name);
	    }
	  }, {
	    key: 'parse',
	    value: function parse(node, component) {
	      _Views.Views.parse(node, component);
	    }
	  }, {
	    key: 'run',
	    value: function run(element) {
	      if (!!element) {
	        _dom.DOM.parse(element);
	      } else {
	        document.addEventListener('DOMContentLoaded', function (event) {
	          _dom.DOM.parse(event.target.body);
	        });
	      }
	    }
	  }]);
	
	  return Components;
	}();

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DOM = undefined;
	
	var _Components = __webpack_require__(6);
	
	var _Injector = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DOM = exports.DOM = (_temp = _class = function () {
	  function DOM() {
	    _classCallCheck(this, DOM);
	  }
	
	  _createClass(DOM, null, [{
	    key: 'attrs',
	    value: function attrs(node) {
	      if (!!node) {
	        var nodeAttrs = Array.prototype.slice.call(node.attributes);
	
	        return nodeAttrs.map(function (attribute) {
	          return {
	            name: attribute.name,
	            value: attribute.value,
	            escaped: attribute.value.replace(/(^|[^\\])"/g, '$1\\\"')
	          };
	        });
	      }
	    }
	  }, {
	    key: 'walk',
	    value: function walk(node, callback) {
	      if (!!node) {
	        do {
	          callback(node);
	
	          if (!!node && node.hasChildNodes()) {
	            DOM.walk(node.firstChild, callback);
	          }
	        } while (!!(node = node.nextSibling));
	      }
	
	      return DOM;
	    }
	  }, {
	    key: 'clean',
	    value: function clean(node) {
	      if (!!node) {
	        for (var n = 0; n < node.childNodes.length; n++) {
	          var child = node.childNodes[n];
	          if (child.nodeType === 8 || child.nodeType === 3 && !/\S/.test(child.nodeValue)) {
	            node.removeChild(child);
	            n--;
	          } else if (child.nodeType === 1) {
	            DOM.clean(child);
	          }
	        }
	      }
	
	      return DOM;
	    }
	  }, {
	    key: 'childs',
	    value: function childs(node) {
	      var childNodes = [];
	
	      if (!!node) {
	        DOM.walk(node, function (n) {
	          childNodes.push(n);
	        });
	        childNodes.shift();
	      }
	
	      return childNodes;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(node) {
	      if (!!node) {
	        var childNodes = DOM.childs(node);
	
	        while (node.firstChild) {
	          node.removeChild(node.firstChild);
	        }
	
	        childNodes.forEach(function (element) {
	          var componentName = _Components.Components.normalize(element);
	
	          if (!!_Components.Components.exists(componentName)) {
	            if (!!_Injector.Injector.hasInstance(componentName)) {
	              if (element.parentNode) {
	                element.parentNode.appendChild(element);
	              } else {
	                node.appendChild(element);
	              }
	
	              // let attrs = !!element.hasAttributes() ? DOM.attrs(element) : [];
	              _Components.Components.parse(element, _Components.Components.get(componentName));
	            } else {
	              throw new Error('Error, no instance for component: ' + componentName);
	            }
	          } else {
	            if (element.parentNode) {
	              element.parentNode.appendChild(element);
	            } else {
	              node.appendChild(element);
	            }
	          }
	        });
	      }
	
	      return DOM;
	    }
	  }, {
	    key: 'fragment',
	    value: function fragment(node) {
	      var domFragment = document.createDocumentFragment();
	
	      if (!!node) {
	        while (node.firstChild) {
	          domFragment.appendChild(node.firstChild);
	        }
	      }
	
	      return domFragment;
	    }
	  }]);
	
	  return DOM;
	}(), _class.cache = [], _temp);

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Views = undefined;
	
	var _Render = __webpack_require__(9);
	
	var _dom = __webpack_require__(7);
	
	var _EventBus = __webpack_require__(5);
	
	var _EventNameNormalizer = __webpack_require__(14);
	
	var _EventBinder = __webpack_require__(15);
	
	var _HTTP = __webpack_require__(16);
	
	var _Injector = __webpack_require__(3);
	
	var _Directives = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Views = exports.Views = (_temp = _class = function () {
	  function Views() {
	    _classCallCheck(this, Views);
	  }
	
	  _createClass(Views, null, [{
	    key: 'parseModel',
	    value: function parseModel(key, target) {
	      var view = Views.views[target.name],
	          node = view.nodeCached,
	
	      // template = view.templateCached,
	      instance = _Injector.Injector.instances[target.name];
	      // value = instance[key];
	
	      _dom.DOM.walk(node, function () {
	        _dom.DOM.cache.forEach(function (cacheNode) {
	          var regexp = new RegExp(_Render.Render.START_DELIMITER + key + _Render.Render.END_DELIMITER, 'gm');
	
	          if (cacheNode.data instanceof Array) {
	            cacheNode.data.forEach(function (attr) {
	              if (!!regexp.test(attr.value)) {
	                cacheNode.node.setAttribute(attr.name, instance[key]);
	              }
	            });
	          } else {
	            if (!!regexp.test(cacheNode.data)) {
	              cacheNode.node.nodeValue = instance[key];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'parseComponent',
	    value: function parseComponent(node, template, data, target) {
	      var wrapper = document.createElement('div');
	      wrapper.innerHTML = _Render.Render.normalize(template);
	
	      var nodeParsed = _Directives.Directives.parse(wrapper, data, target);
	
	      if (!!node) {
	        while (node.firstChild) {
	          node.removeChild(node.firstChild);
	        }
	
	        node.appendChild(_dom.DOM.fragment(nodeParsed));
	
	        _dom.DOM.walk(node, function (n) {
	          var regexp = new RegExp(_Render.Render.START_DELIMITER + '.*' + _Render.Render.END_DELIMITER, 'gm');
	
	          if (n.nodeType === 1 && n.hasAttributes()) {
	            _dom.DOM.attrs(n).forEach(function (attr) {
	              if (!!regexp.test(attr.value)) {
	                _dom.DOM.cache.push({
	                  node: n,
	                  data: _dom.DOM.attrs(n).slice()
	                });
	              }
	            });
	          } else if (n.data) {
	            if (!!regexp.test(n.data)) {
	              _dom.DOM.cache.push({
	                node: n,
	                data: n.data.slice()
	              });
	            }
	            n.data = _Render.Render.render(n.data, data);
	          }
	        });
	
	        _dom.DOM.parse(node).walk(node, function (element) {
	          if (element.nodeType === 1) {
	            var attrs = !!element.hasAttributes() ? _dom.DOM.attrs(element) : [];
	            _EventBinder.EventBinder.bind(element, attrs, target);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'parseView',
	    value: function parseView(node, template, instance, target) {
	      var eventName = _EventNameNormalizer.EventNameNormalizer.normalize(target, _EventBus.EventBus.CHANGE_DETECTED);
	
	      Views.parseComponent(node, template, instance, target);
	
	      _EventBus.EventBus.subscribe(eventName, function () {
	        Views.parseComponent(node, template, instance, target);
	      });
	    }
	  }, {
	    key: 'resolve',
	    value: function resolve(view, node, target, instance) {
	      if (!!view) {
	        var promise = undefined;
	
	        if (!!view.hasOwnProperty(Views.TEMPLATE_URL)) {
	          promise = _HTTP.HTTP.get(view[Views.TEMPLATE_URL]);
	        } else if (!!view.hasOwnProperty(Views.TEMPLATE) && !view.hasOwnProperty(Views.TEMPLATE_URL)) {
	          promise = Promise.resolve(view[Views.TEMPLATE]);
	        } else {
	          throw new Exception('View need templateUrl or template attributes');
	        }
	
	        promise.then(function (template) {
	          view.templateCached = template;
	          view.nodeCached = node;
	
	          Views.parseView(node, template, instance, target);
	        });
	      }
	    }
	  }, {
	    key: 'parse',
	    value: function parse(node, component) {
	      if (!!component) {
	        var view = Views.views[component.target.name],
	            target = component.target,
	            instance = _Injector.Injector.instances[target.name];
	
	        Views.resolve(view, node, target, instance);
	      }
	    }
	  }]);
	
	  return Views;
	}(), _class.views = {}, _temp);
	
	Views.TEMPLATE_URL = 'templateUrl';
	Views.TEMPLATE = 'template';

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Render = undefined;
	
	var _util = __webpack_require__(2);
	
	var _Directives = __webpack_require__(10);
	
	var _Filters = __webpack_require__(12);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Render = exports.Render = function () {
	  function Render() {
	    _classCallCheck(this, Render);
	  }
	
	  _createClass(Render, null, [{
	    key: 'normalize',
	    value: function normalize(html) {
	      var coreDirectives = [];
	      for (var directive in _Directives.Directives.getDirectives()) {
	        // console.log(directive, Directives.get(directive).config);
	        coreDirectives.push(directive.replace(_Directives.Directives.PREFIX, ''));
	      }
	
	      var pattern = '\\*(' + coreDirectives.join('|') + ')';
	      var regExp = new RegExp(pattern, 'gm');
	
	      return html.replace(regExp, function (p1, p2) {
	        return _Directives.Directives.PREFIX + p2;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render(html, options) {
	      var re = new RegExp(Render.START_DELIMITER + '([^' + Render.END_DELIMITER + ']+)?' + Render.END_DELIMITER, 'g'),
	          reExp = /^( )?({|})(.*)*/g,
	          code = 'var r=[];\n',
	          cursor = 0,
	          match;
	
	      var add = function add(line, js) {
	        js ? code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n' : code += line !== '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '';
	        return add;
	      };
	
	      while (!!(match = re.exec(html))) {
	        if (match[1].indexOf('|') > -1) {
	          var _context;
	
	          var filters = match[1].split('|').map(function (filter) {
	            return filter.trim();
	          });
	          var value = filters.shift();
	
	          filters = filters.map(function (name) {
	            if (name.indexOf(':') === -1) {
	              return {
	                filter: _Filters.Filters.get(name).render,
	                value: null
	              };
	            }
	            var filterValue = name.substring(name.indexOf(':') + 1),
	                filterName = name.substring(0, name.indexOf(':'));
	
	            return {
	              filter: _Filters.Filters.get(filterName).render,
	              value: filterValue
	            };
	          });
	
	          var filterName = (_context = filters, _util.first).call(_context);
	
	          options['filter'] = filterName.filter;
	          options['filterValue'] = filterName.value;
	
	          add(html.slice(cursor, match.index))('this.filter' + '(this.' + value + ', this.filterValue)', true);
	        } else {
	          add(html.slice(cursor, match.index))('this.' + match[1], true);
	        }
	        cursor = match.index + match[0].length;
	      }
	
	      add(html.substr(cursor, html.length - cursor));
	      code += 'return r.join("");';
	
	      // console.log(code);
	      // console.log(html);
	      // console.log(new Function(code.replace(/[\r\t\n]/g, '')).apply(options));
	
	      return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
	    }
	  }]);
	
	  return Render;
	}();
	
	Render.START_DELIMITER = '{{';
	Render.END_DELIMITER = '}}';

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Directives = undefined;
	
	var _DataDirectives = __webpack_require__(11);
	
	var _dom = __webpack_require__(7);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Directives = exports.Directives = function () {
	  function Directives() {
	    _classCallCheck(this, Directives);
	  }
	
	  _createClass(Directives, null, [{
	    key: 'has',
	    value: function has(name) {
	      return !!_DataDirectives.DataDirectives.get(name);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return _DataDirectives.DataDirectives.get(name);
	    }
	  }, {
	    key: 'getDirectives',
	    value: function getDirectives() {
	      return _DataDirectives.DataDirectives.data;
	    }
	  }, {
	    key: 'parseElement',
	    value: function parseElement(element, data) {
	      if (!!element.hasAttributes()) {
	        var directives = _dom.DOM.attrs(element).filter(function (attr) {
	          return Directives.has(attr.name);
	        }).map(function (attr) {
	          return {
	            directive: Directives.get(attr.name),
	            value: attr.value
	          };
	        });
	
	        Directives.render(element, directives, data);
	      }
	
	      return element;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(node, data, target) {
	      var childNodes = Array.prototype.slice.call(node.getElementsByTagName('*')).filter(function (element) {
	        return element.nodeType === 1;
	      });
	
	      childNodes.forEach(function (element) {
	        if (!!element.hasAttributes()) {
	          var directives = _dom.DOM.attrs(element).filter(function (attr) {
	            return Directives.has(attr.name);
	          }).map(function (attr) {
	            return {
	              directive: Directives.get(attr.name),
	              value: attr.value,
	              target: target
	            };
	          });
	
	          Directives.render(element, directives, data);
	        }
	      });
	
	      return node;
	    }
	  }, {
	    key: 'render',
	    value: function render(element, directives, data) {
	      directives.forEach(function (input) {
	        var directive = input.directive;
	        var value = input.value;
	        var target = input.target;
	
	        directive.instance.render(element, data, value, directive.config, target);
	      });
	    }
	  }]);
	
	  return Directives;
	}();
	
	Directives.PREFIX = 'data-';

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DataDirectives = undefined;
	
	var _Injector = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataDirectives = exports.DataDirectives = (_temp = _class = function () {
	  function DataDirectives() {
	    _classCallCheck(this, DataDirectives);
	  }
	
	  _createClass(DataDirectives, null, [{
	    key: 'normalize',
	    value: function normalize(name) {
	      name = name.charAt(0).toLowerCase() + name.slice(1);
	      return name.replace(/([A-Z])/g, function ($1) {
	        return '-' + $1.toLowerCase();
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add(name, directive, config) {
	      DataDirectives.data[DataDirectives.normalize(name)] = {
	        target: directive,
	        instance: _Injector.Injector.get(directive),
	        config: config
	      };
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return DataDirectives.data[name];
	    }
	  }]);
	
	  return DataDirectives;
	}(), _class.data = {}, _temp);

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Filters = undefined;
	
	var _DataFilters = __webpack_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Filters = exports.Filters = function () {
	  function Filters() {
	    _classCallCheck(this, Filters);
	  }
	
	  _createClass(Filters, null, [{
	    key: 'get',
	    value: function get(name) {
	      return _DataFilters.DataFilters.get(name);
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters() {
	      return _DataFilters.DataFilters.data;
	    }
	  }]);
	
	  return Filters;
	}();

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DataFilters = undefined;
	
	var _Injector = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function normalizeFilterName(name) {
	  return name.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
	    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
	  }).replace(/\s+/g, '');
	}
	
	var DataFilters = exports.DataFilters = (_temp = _class = function () {
	  function DataFilters() {
	    _classCallCheck(this, DataFilters);
	  }
	
	  _createClass(DataFilters, null, [{
	    key: 'add',
	    value: function add(name, filter) {
	      DataFilters.data[normalizeFilterName(name)] = _Injector.Injector.get(filter);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return DataFilters.data[name];
	    }
	  }]);
	
	  return DataFilters;
	}(), _class.data = {}, _temp);

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventNameNormalizer = exports.EventNameNormalizer = function () {
	  function EventNameNormalizer() {
	    _classCallCheck(this, EventNameNormalizer);
	  }
	
	  _createClass(EventNameNormalizer, null, [{
	    key: 'normalize',
	    value: function normalize(target, eventName) {
	      if (!!target && !!target.name) {
	        return target.name.toUpperCase() + '_' + eventName;
	      }
	    }
	  }]);
	
	  return EventNameNormalizer;
	}();

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventBinder = undefined;
	
	var _Injector = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function setPrimitive(value) {
	  if (!isNaN(value)) {
	    // check integer
	    if (/[0-9]+/.test(value)) {
	      return parseInt(value, 10);
	    }
	
	    // check float
	    if (/^-?(\d+\.?\d*)$|(\d*\.?\d+)$/.test(value)) {
	      return parseFloat(value);
	    }
	  }
	
	  return value;
	}
	
	var EventBinder = exports.EventBinder = (_temp = _class = function () {
	  function EventBinder() {
	    _classCallCheck(this, EventBinder);
	  }
	
	  _createClass(EventBinder, null, [{
	    key: 'bindInstance',
	    value: function bindInstance(element, attrs, instance) {
	      if (attrs.length > 0) {
	        attrs.forEach(function (attr) {
	          var attrName = attr.name,
	              attrValue = attr.value;
	
	          if (attrName.charAt(0) === '_') {
	            var eventName = attrName.substring(1);
	
	            element.addEventListener(eventName, function () {
	              var data = element.contextData;
	              var methodName = attrValue.match(/^(.*)\(/mi)[1];
	              var args = attrValue.match(/^\s*[^\(]*\(\s*([^\)]*)\)/m)[1];
	              args = args.length > 0 ? args.split(/,/) : [];
	              args = args.map(function (arg) {
	                return setPrimitive(arg);
	              });
	
	              if (!!data) {
	                args = args.map(function (arg) {
	                  if (!!data.hasOwnProperty(arg)) {
	                    arg = data[arg];
	                  }
	
	                  return arg;
	                });
	              }
	
	              instance[methodName].apply(instance, args);
	            }, false);
	          }
	
	          if (attrName === 'data-model') {
	            element.addEventListener('input', function () {
	              instance[attrValue] = element.value;
	            }, false);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'bind',
	    value: function bind(element, attrs, target) {
	      if (attrs.length > 0) {
	        var instance = _Injector.Injector.instances[target.name];
	        EventBinder.bindInstance(element, attrs, instance);
	      }
	    }
	  }]);
	
	  return EventBinder;
	}(), _class.DataCache = {}, _temp);

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTTP = function () {
	  function HTTP() {
	    _classCallCheck(this, HTTP);
	  }
	
	  _createClass(HTTP, null, [{
	    key: 'init',
	    value: function init() {
	      var options = arguments.length <= 0 || arguments[0] === undefined ? { method: 'GET', headers: {}, cache: false, async: false, timeout: 0 } : arguments[0];
	
	      var toQueryString = function toQueryString(obj) {
	        var parts = [];
	        for (var i in obj) {
	          if (obj.hasOwnProperty(i)) {
	            parts.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]));
	          }
	        }
	        return parts.join('&');
	      };
	
	      var appendQuery = function appendQuery(url, query) {
	        if (query === '') return url;
	        return (url + '&' + query).replace(/[&?]{1,2}/, '?');
	      };
	
	      var createCORSRequest = function createCORSRequest(method, url) {
	        var xhr = new XMLHttpRequest();
	
	        if ('withCredentials' in xhr) {
	          xhr.open(method, url, true);
	        } else if (typeof XDomainRequest !== 'undefined') {
	          xhr = new XDomainRequest();
	          xhr.open(method, url);
	        } else {
	          xhr = null;
	        }
	
	        return xhr;
	      };
	
	      if (!options.url) {
	        throw new Error('Url is needed');
	      }
	
	      if (options.params) {
	        options.url = appendQuery(options.url, toQueryString(options.params));
	      }
	
	      if (options && options.data) {
	        options.headers['Content-Type'] = options.headers['Content-Type'] || 'application/x-www-form-urlencoded';
	        var queryString = options.data ? toQueryString(options.data) : null;
	        if (queryString) {
	          options.headers['Content-length'] = queryString.length;
	        }
	      }
	
	      if (options.cache) {
	        options.url = appendQuery(options.url, '_=' + +new Date());
	      }
	
	      var promise = new Promise(function (resolve, reject) {
	        var request = createCORSRequest(options.method, options.url);
	
	        if (options && options.headers) {
	          Object.keys(options.headers).forEach(function (key) {
	            request.setRequestHeader(key, options.headers[key]);
	          });
	        }
	
	        if (options.withCredentials) {
	          request.withCredentials = true;
	        }
	
	        request.onload = function () {
	          if (request.status === 200) {
	            resolve(request.responseText);
	          } else {
	            reject(new Error('Status code was ' + request.status));
	          }
	        };
	        request.onerror = function () {
	          reject(new Error('Can\'t XHR ' + JSON.stringify(options.url)));
	        };
	
	        if (options.timeout > 0) {
	          var timeout = setTimeout(function () {
	            request.onreadystatechange = function () {};
	            request.abort();
	            clearTimeout(timeout);
	          }, options.timeout);
	        }
	
	        request.send(options && options.data ? toQueryString(options.data) : null);
	      });
	
	      return promise;
	    }
	  }, {
	    key: 'get',
	    value: function get(url) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      options.method = 'GET';
	      options.url = url;
	
	      return this.init(options);
	    }
	  }, {
	    key: 'post',
	    value: function post(url) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      options.method = 'POST';
	      options.url = url;
	
	      return this.init(options);
	    }
	  }, {
	    key: 'put',
	    value: function put(url, options) {
	      options.method = 'PUT';
	      options.url = url;
	
	      return this.init(options);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(url, options) {
	      options.method = 'DELETE';
	      options.url = url;
	
	      return this.init(options);
	    }
	  }, {
	    key: 'head',
	    value: function head(url, options) {
	      options.method = 'HEAD';
	      options.url = url;
	
	      return this.init(options);
	    }
	  }, {
	    key: 'trace',
	    value: function trace(url, options) {
	      options.method = 'TRACE';
	      options.url = url;
	
	      return this.init(options);
	    }
	  }, {
	    key: 'options',
	    value: function options(url, _options) {
	      _options.method = 'OPTIONS';
	      _options.url = url;
	
	      return this.init(_options);
	    }
	  }, {
	    key: 'patch',
	    value: function patch(url, options) {
	      options.method = 'PATCH';
	      options.url = url;
	
	      return this.init(options);
	    }
	  }]);
	
	  return HTTP;
	}();

	exports.HTTP = HTTP;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DataComponents = undefined;
	
	var _util = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataComponents = exports.DataComponents = (_temp = _class = function () {
	  function DataComponents() {
	    _classCallCheck(this, DataComponents);
	  }
	
	  _createClass(DataComponents, null, [{
	    key: 'normalize',
	    value: function normalize(name) {
	      var _context;
	
	      return (_context = name.toLowerCase().replace(/\W+(.)/g, function (x, chr) {
	        return chr.toUpperCase();
	      }), _util.ucfirst).call(_context);
	    }
	  }, {
	    key: 'add',
	    value: function add(name, component, config) {
	      DataComponents.data[name] = {
	        target: component,
	        config: config
	      };
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return DataComponents.data[name];
	    }
	  }]);
	
	  return DataComponents;
	}(), _class.data = {}, _temp);

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Binder = undefined;
	exports.Bindable = Bindable;
	
	var _EventBus = __webpack_require__(5);
	
	var _EventNameNormalizer = __webpack_require__(14);
	
	var _Injector = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function Bindable(target, key) {
	  if (target.bindableFields) {
	    target.bindableFields.push(key);
	  } else {
	    target.bindableFields = [key];
	  }
	}
	
	var Binder = exports.Binder = function () {
	  function Binder() {
	    _classCallCheck(this, Binder);
	  }
	
	  _createClass(Binder, null, [{
	    key: 'bindArray',
	    value: function bindArray(target, key, eventName) {
	      //
	      // override array methods
	      // http://stackoverflow.com/questions/5100376/how-to-watch-for-array-changes
	      //
	
	      var methods = ['push', 'pop', 'reverse', 'shift', 'unshift', 'splice'];
	      methods.forEach(function (name) {
	        try {
	          Object.defineProperty(target[key], name, {
	            configurable: false,
	            enumerable: false,
	            writable: false,
	            value: function value() {
	              Array.prototype[name].apply(this, arguments);
	              _EventBus.EventBus.publish(eventName);
	              return this.length;
	            }
	          });
	        } catch (e) {}
	      });
	
	      // Binder.bindOther(target, key, eventName);
	    }
	  }, {
	    key: 'bindOther',
	    value: function bindOther(target, key, eventName) {
	      var value = target[key],
	          privateProperty = key + '_' + +new Date();
	
	      Object.defineProperty(target, privateProperty, {
	        enumerable: false,
	        configurable: false,
	        writable: true
	      });
	
	      Object.defineProperty(target, key, {
	        set: function set(newValue) {
	          this[privateProperty] = newValue;
	          _EventBus.EventBus.publish(eventName);
	        },
	        get: function get() {
	          return this[privateProperty];
	        }
	      });
	
	      target[key] = value;
	    }
	  }, {
	    key: 'bindInstance',
	    value: function bindInstance(instance, instanceName) {
	      if (!!instance.bindableFields) {
	        (function () {
	          var target = {
	            name: instanceName
	          };
	          var eventName = _EventNameNormalizer.EventNameNormalizer.normalize(target, _EventBus.EventBus.CHANGE_DETECTED);
	
	          instance.bindableFields.forEach(function (key) {
	            if (instance[key] instanceof Array) {
	              Binder.bindArray(instance, key, eventName);
	            } else {
	              Binder.bindOther(instance, key, eventName);
	            }
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'run',
	    value: function run(instance, instanceName) {
	      if (!!instance) {
	        Binder.bindInstance(instance, instanceName);
	      } else {
	        for (var name in _Injector.Injector.instances) {
	          Binder.bindInstance(_Injector.Injector.instances[name], instanceName);
	        }
	      }
	    }
	  }]);
	
	  return Binder;
	}();

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.i18n = undefined;
	
	var _i18nDate = __webpack_require__(20);
	
	var _i18nNumber = __webpack_require__(32);
	
	var _i18nTranslate = __webpack_require__(33);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var i18n = exports.i18n = (_temp = _class = function () {
	  _createClass(i18n, null, [{
	    key: 'from',
	    value: function from(input, config) {
	      return new i18n(input, config);
	    }
	  }]);
	
	  function i18n(input, config) {
	    _classCallCheck(this, i18n);
	
	    this.input = input;
	    this.config = config;
	  }
	
	  _createClass(i18n, [{
	    key: 'isDate',
	    value: function isDate(input) {
	      return input instanceof Date;
	    }
	  }, {
	    key: 'isNumber',
	    value: function isNumber(input) {
	      return typeof input === 'number';
	    }
	  }, {
	    key: 'isString',
	    value: function isString(input) {
	      return typeof input === 'string';
	    }
	  }, {
	    key: 'locale',
	    value: function locale(input) {
	      return input.replace('-', '_');
	    }
	  }, {
	    key: 'format',
	    value: function format(opts) {
	      if (!!this.isDate(this.input)) {
	        var options = _i18nDate.i18nDate.fromFormat(opts, this.config);
	
	        return this.input.toLocaleString(this.config.locale, options);
	      }
	
	      if (!!this.isNumber(this.input)) {
	        var options = _i18nNumber.i18nNumber.fromFormat(opts, this.config);
	
	        if (opts === _i18nNumber.i18nNumber.PERCENT) {
	          this.input /= 100;
	        }
	
	        return this.input.toLocaleString(this.config.locale, options);
	      }
	
	      if (!!this.isString(this.input)) {
	        var map = this.config.translations[this.locale(this.config.locale)];
	        return _i18nTranslate.i18nTranslate.from(map, this.input).translate(opts);
	      }
	    }
	  }], [{
	    key: 'getConfig',
	    value: function getConfig() {
	      return i18n.configs;
	    }
	  }, {
	    key: 'setConfig',
	    value: function setConfig(key, value) {
	      i18n.configs[key] = value;
	    }
	  }]);
	
	  return i18n;
	}(), _class.configs = null, _temp);
	
	i18n.TRANSLATION_LOADED = 'TRANSLATION_LOADED';

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.i18nDate = undefined;
	
	var _util = __webpack_require__(2);
	
	var _i18nDateFormatter = __webpack_require__(21);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var i18nDate = exports.i18nDate = function () {
	  function i18nDate() {
	    _classCallCheck(this, i18nDate);
	  }
	
	  _createClass(i18nDate, null, [{
	    key: 'fromFormat',
	
	    /**
	     * Formats
	     *
	     * LT   -> 8:30 PM
	     * LTS  -> 8:30:25 PM
	     * L    -> 09/04/1986
	     * l    -> 9/4/1986
	     * LL   -> September 4 1986
	     * ll   -> Sep 4 1986
	     * LLL  -> September 4 1986 8:30 PM
	     * lll  -> Sep 4 1986 8:30 PM
	     * LLLL -> Thursday, September 4 1986 8:30 PM
	     * llll -> Thu, Sep 4 1986 8:30 PM
	     */
	
	    value: function fromFormat(format, config) {
	      var options = {};
	
	      if (!!config['timezone']) {
	        options.timeZone = config['timezone'];
	      }
	
	      options.hour12 = !!options.hour12;
	
	      if (!!format) {
	        return i18nDate.createFromFormat(format, options);
	      }
	
	      return options;
	    }
	  }, {
	    key: 'createFromFormat',
	    value: function createFromFormat(format, options) {
	      var outputOptions = JSON.parse(JSON.stringify(options));
	      var dateOptions = _i18nDateFormatter.i18nDateFormatter.from(format).getOptions();
	
	      return (0, _util.merge)(outputOptions, dateOptions);
	    }
	  }]);
	
	  return i18nDate;
	}();

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Time
	// TimeSeconds
	// MonthDayYearNumeric
	// MonthDayYear2Digit
	// MonthNameDayMonthYear
	// MonthNameShortDayMonthYear
	// MonthNameDayMonthYearTime
	// MonthNameShortDayMonthYearTime
	// DayOfWeekMonthNameDayYearTime
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.i18nDateFormatter = undefined;
	
	var _Time = __webpack_require__(22);
	
	var _TimeSeconds = __webpack_require__(23);
	
	var _MonthDayYearNumeric = __webpack_require__(24);
	
	var _MonthDayYear2Digit = __webpack_require__(25);
	
	var _MonthNameDayMonthYear = __webpack_require__(26);
	
	var _MonthNameShortDayMonthYear = __webpack_require__(27);
	
	var _MonthNameDayMonthYearTime = __webpack_require__(28);
	
	var _MonthNameShortDayMonthYearTime = __webpack_require__(29);
	
	var _DayOfWeekMonthNameDayYearTime = __webpack_require__(30);
	
	var _DayOfWeekShortMonthNameShortDayYearTime = __webpack_require__(31);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// DayOfWeekShortMonthNameShortDayYearTime
	
	var i18nDateFormatter = exports.i18nDateFormatter = function () {
	  function i18nDateFormatter() {
	    _classCallCheck(this, i18nDateFormatter);
	  }
	
	  _createClass(i18nDateFormatter, null, [{
	    key: 'from',
	    value: function from(format) {
	      if (format === 'LT') {
	        return new _Time.LT();
	      }
	
	      if (format === 'LTS') {
	        return new _TimeSeconds.LTS();
	      }
	
	      if (format === 'L') {
	        return new _MonthDayYearNumeric.L();
	      }
	
	      if (format === 'l') {
	        return new _MonthDayYear2Digit.l();
	      }
	
	      if (format === 'LL') {
	        return new _MonthNameDayMonthYear.LL();
	      }
	
	      if (format === 'll') {
	        return new _MonthNameShortDayMonthYear.ll();
	      }
	
	      if (format === 'LLL') {
	        return new _MonthNameDayMonthYearTime.LLL();
	      }
	
	      if (format === 'lll') {
	        return new _MonthNameShortDayMonthYearTime.lll();
	      }
	
	      if (format === 'LLLL') {
	        return new _DayOfWeekMonthNameDayYearTime.LLLL();
	      }
	
	      if (format === 'llll') {
	        return new _DayOfWeekShortMonthNameShortDayYearTime.llll();
	      }
	    }
	  }]);
	
	  return i18nDateFormatter;
	}();

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LT = exports.LT = function () {
	  function LT() {
	    _classCallCheck(this, LT);
	  }
	
	  _createClass(LT, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        hour: 'numeric',
	        minute: 'numeric',
	        hour12: true
	      };
	    }
	  }]);
	
	  return LT;
	}();

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LTS = exports.LTS = function () {
	  function LTS() {
	    _classCallCheck(this, LTS);
	  }
	
	  _createClass(LTS, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        hour: 'numeric',
	        minute: 'numeric',
	        second: 'numeric',
	        hour12: true
	      };
	    }
	  }]);
	
	  return LTS;
	}();

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var L = exports.L = function () {
	  function L() {
	    _classCallCheck(this, L);
	  }
	
	  _createClass(L, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: '2-digit',
	        day: '2-digit'
	      };
	    }
	  }]);
	
	  return L;
	}();

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var l = exports.l = function () {
	  function l() {
	    _classCallCheck(this, l);
	  }
	
	  _createClass(l, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: 'numeric',
	        day: 'numeric'
	      };
	    }
	  }]);
	
	  return l;
	}();

/***/ },
/* 26 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LL = exports.LL = function () {
	  function LL() {
	    _classCallCheck(this, LL);
	  }
	
	  _createClass(LL, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: 'long',
	        day: 'numeric'
	      };
	    }
	  }]);
	
	  return LL;
	}();

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ll = exports.ll = function () {
	  function ll() {
	    _classCallCheck(this, ll);
	  }
	
	  _createClass(ll, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: 'short',
	        day: 'numeric'
	      };
	    }
	  }]);
	
	  return ll;
	}();

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LLL = exports.LLL = function () {
	  function LLL() {
	    _classCallCheck(this, LLL);
	  }
	
	  _createClass(LLL, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: 'long',
	        day: 'numeric',
	        hour: 'numeric',
	        minute: 'numeric',
	        hour12: true
	      };
	    }
	  }]);
	
	  return LLL;
	}();

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var lll = exports.lll = function () {
	  function lll() {
	    _classCallCheck(this, lll);
	  }
	
	  _createClass(lll, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: 'short',
	        day: 'numeric',
	        hour: 'numeric',
	        minute: 'numeric',
	        hour12: true
	      };
	    }
	  }]);
	
	  return lll;
	}();

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LLLL = exports.LLLL = function () {
	  function LLLL() {
	    _classCallCheck(this, LLLL);
	  }
	
	  _createClass(LLLL, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: 'long',
	        weekday: 'long',
	        day: 'numeric',
	        hour: 'numeric',
	        minute: 'numeric',
	        hour12: true
	      };
	    }
	  }]);
	
	  return LLLL;
	}();

/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var llll = exports.llll = function () {
	  function llll() {
	    _classCallCheck(this, llll);
	  }
	
	  _createClass(llll, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      return {
	        year: 'numeric',
	        month: 'short',
	        weekday: 'short',
	        day: 'numeric',
	        hour: 'numeric',
	        minute: 'numeric',
	        hour12: true
	      };
	    }
	  }]);
	
	  return llll;
	}();

/***/ },
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var i18nNumber = exports.i18nNumber = function () {
	  function i18nNumber() {
	    _classCallCheck(this, i18nNumber);
	  }
	
	  _createClass(i18nNumber, null, [{
	    key: 'fromFormat',
	    value: function fromFormat(format, config) {
	      var options = {
	        style: i18nNumber.DECIMAL
	      };
	
	      if (format === i18nNumber.CURRENCY) {
	        options.style = i18nNumber.CURRENCY;
	        options.currency = config.currency;
	      }
	
	      if (format === i18nNumber.PERCENT) {
	        options.style = i18nNumber.PERCENT;
	      }
	
	      return options;
	    }
	  }]);
	
	  return i18nNumber;
	}();
	
	i18nNumber.DECIMAL = 'decimal';
	i18nNumber.PERCENT = 'percent';
	i18nNumber.CURRENCY = 'currency';

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var i18nTranslate = exports.i18nTranslate = function () {
	  _createClass(i18nTranslate, null, [{
	    key: 'from',
	    value: function from(map, path) {
	      return new i18nTranslate(map, path);
	    }
	  }]);
	
	  function i18nTranslate(map, path) {
	    _classCallCheck(this, i18nTranslate);
	
	    this.map = map;
	    this.path = path;
	  }
	
	  _createClass(i18nTranslate, [{
	    key: 'index',
	    value: function index(obj, is, value) {
	      if (typeof is === 'string') {
	        return this.index(obj, is.split('.'), value);
	      } else if (is.length === 1 && value !== undefined) {
	        // return obj[is[0]] = value;
	        return value;
	      } else if (is.length === 0) {
	        return obj;
	      }
	
	      return this.index(obj[is[0]], is.slice(1), value);
	    }
	  }, {
	    key: 'isZero',
	    value: function isZero(input) {
	      return input === 0;
	    }
	  }, {
	    key: 'isOne',
	    value: function isOne(input) {
	      return input === 1;
	    }
	  }, {
	    key: 'isGreaterThanOne',
	    value: function isGreaterThanOne(input) {
	      return input > 1;
	    }
	  }, {
	    key: 'plural',
	    value: function plural(value, opts) {
	      var output = undefined;
	
	      if (!!this.isZero(value)) {
	        var _$exec = /=0 \{(.*?)\}/ig.exec(opts);
	
	        var _$exec2 = _slicedToArray(_$exec, 2);
	
	        var v = _$exec2[1];
	
	        output = v.trim();
	      }
	
	      if (!!this.isOne(value)) {
	        var _$exec3 = /=1 \{(.*?)\}/ig.exec(opts);
	
	        var _$exec4 = _slicedToArray(_$exec3, 2);
	
	        var v = _$exec4[1];
	
	        output = v.trim();
	      }
	
	      if (!!this.isGreaterThanOne(value)) {
	        var _$exec5 = /other \{(.*?)\}/ig.exec(opts);
	
	        var _$exec6 = _slicedToArray(_$exec5, 2);
	
	        var v = _$exec6[1];
	
	        output = v.trim().replace('#', value);
	      }
	
	      return output;
	    }
	  }, {
	    key: 'isMale',
	    value: function isMale(input) {
	      return input.toLowerCase() === 'male';
	    }
	  }, {
	    key: 'isFemale',
	    value: function isFemale(input) {
	      return input.toLowerCase() === 'female';
	    }
	  }, {
	    key: 'gender',
	    value: function gender(value, opts) {
	      var output = undefined;
	
	      if (!!this.isMale(value)) {
	        var _$exec7 = /male \{(.*?)\}/ig.exec(opts);
	
	        var _$exec8 = _slicedToArray(_$exec7, 2);
	
	        var v = _$exec8[1];
	
	        output = v.trim();
	      } else if (!!this.isFemale(value)) {
	        var _$exec9 = /female \{(.*?)\}/ig.exec(opts);
	
	        var _$exec10 = _slicedToArray(_$exec9, 2);
	
	        var v = _$exec10[1];
	
	        output = v.trim();
	      } else {
	        var _$exec11 = /other \{(.*?)\}/ig.exec(opts);
	
	        var _$exec12 = _slicedToArray(_$exec11, 2);
	
	        var v = _$exec12[1];
	
	        output = v.trim();
	      }
	
	      return output;
	    }
	  }, {
	    key: 'translate',
	    value: function translate(values) {
	      var value = this.index(this.map, this.path),
	          match = undefined,
	          re = new RegExp('{{(.*)?}}', 'g');
	
	      if (!!values) {
	        while (!!(match = re.exec(value))) {
	          var _match$1$split = match[1].split(',');
	
	          var _match$1$split2 = _slicedToArray(_match$1$split, 3);
	
	          var variable = _match$1$split2[0];
	          var callback = _match$1$split2[1];
	          var options = _match$1$split2[2];
	
	          value = this[callback.trim()].call(this, values[variable], options.trim());
	        }
	      }
	
	      return value;
	    }
	  }]);
	
	  return i18nTranslate;
	}();

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** dali.min.js
 **/